export const mutations = {
  SET_STATE(state, data) {
    Object.assign(state, data);
  },
  SET_ADDRESS_DATA(state, data) {
    state.addressData = data;
  },
  SET_PAYMENT_METHOD(state, data) {
    state.paymentMethod = data;
  }
};

export default mutations;
